import { gql } from "@apollo/client"; import { useQuery } from "@apollo/client/react";
import React from 'react';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DecodeFormBase64 } from '../../../helpers/tools';
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import AuditoriaPrintDetalle from './AuditoriaPrintDetalle';
import ErrorDialog from '../../../components/ErrorDialog';
import moment from 'moment';


const COL_ANCHO_1 = 20;
const COL_ANCHO_2 = 35;
const COL_ANCHO_3 = 10;
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 50,
    paddingHorizontal: 35
  },
  tabla: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 20
    //marginBottom: "20px"

  },
  tablaFila: {
    margin: "auto",
    flexDirection: "row"
  },
  tablaColumna1: {
    width: COL_ANCHO_1 + "%",
    backgroundColor: '#dcdcdc',
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tablaColumna2: {
    width: COL_ANCHO_2 + "%",
    backgroundColor: '#dcdcdc',
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tablaColumna3: {
    width: COL_ANCHO_3 + "%",
    backgroundColor: '#dcdcdc',
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tablaCeldaHeader: {
    margin: 5,
    fontSize: 10,
    fontWeight: 500,
    textAlign: 'center'
  },
  anchoColumna1: {
    width: COL_ANCHO_1 + "%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  anchoColumna2: {
    width: COL_ANCHO_2 + "%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tablaCelda: {
    margin: 5,
    fontSize: 10,
    marginBottom: "30px"
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
    //marginBottom: "20px"
  },
  title: {
    fontSize: 16,
    textAlign: 'center'
  }
});

export default function AuditoriaPrint() {

  const navigate = useNavigate();
  let params = useParams();

  let rows = [];
  function createData(campo, valorAntiguo, valorNuevo, estado) {
    return { campo, valorAntiguo, valorNuevo, estado };
  }

  let auditoriaId = "";

  if (params != "") {
    try {
      auditoriaId = parseInt(DecodeFormBase64(params.auditoriaId), 10);
    } catch {
    }
  }

  // redirecciono a la grilla en caso de no recibir un parámetro numérico
  useEffect(() => {
    if (isNaN(auditoriaId)) {
      navigate('/auditoria');
    }
  }, []);

  const handleCloseDlgError = () => {
    // retorno al auditoria.
    navigate("/auditoria");
  };

  const QPrintAuditoria = gql`
        query QPrintAuditoria($idAuditoria: Int!) {
            printAuditoria(
                idAuditoria: $idAuditoria
            ) 
            {
                success,
                error,
                valorEsperado {
                    idAuditoria,
                    valorAntiguo,
                    valorNuevo,
                    digitoVerificador,
                    tabla,
                    fecha,
                    idUsuario,
                    usuario,
                    digitoValido,
                    idClaveSecundaria,
                    accion,
                    descripcionAccion,
                    pantalla,
                    idClave,
                    ipUsuario,
                    pcUsuario,
                    usuarioImpresion,
                    fechaImpresion,
                    latitud,
                    longitud
                }
            }
        }`;

  const { loading, error, data } = useQuery(QPrintAuditoria, { fetchPolicy: 'no-cache', variables: { idAuditoria: auditoriaId } });

  if (loading) return <CircularProgress disableShrink />;
  if (error) return <ErrorDialog
    id="dlg-error-terminos"
    open={error}
    onClose={handleCloseDlgError}
    mensaje="ERRORDB" />;


  if (data) {
    if (data.printAuditoria.success) {
      const ubicacion = data.printAuditoria.valorEsperado[0].latitud != '' && data.printAuditoria.valorEsperado[0].longitud != '' ?
        data.printAuditoria.valorEsperado[0].latitud + ' ' + data.printAuditoria.valorEsperado[0].longitud :
        's/d';
      return (
        <div>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document
              title="Auditoria">
              <Page size="A4" wrap={true} style={styles.body}>
                <View wrap={true}>
                  <Text style={styles.title}>
                    IMPRESION DE AUDITORIA
                  </Text>
                  <View style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}>
                    <View style={{ flex: 1 }}>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Usuario: {data.printAuditoria.valorEsperado[0].usuario}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>IdUsuario: {data.printAuditoria.valorEsperado[0].idUsuario}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>IP: {data.printAuditoria.valorEsperado[0].ipUsuario}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Ubicación: {ubicacion} </Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Usuario Impresión: {data.printAuditoria.valorEsperado[0].usuarioImpresion}</Text>
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Acción: {data.printAuditoria.valorEsperado[0].accion}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Descripcion Acción: {data.printAuditoria.valorEsperado[0].descripcionAccion}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Pantalla: {data.printAuditoria.valorEsperado[0].pantalla}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Id Clave: {data.printAuditoria.valorEsperado[0].idClave}</Text>
                      <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>Fecha Impresión: {moment(data.printAuditoria.valorEsperado[0].fechaImpresion).format("DD/MM/YYYY HH:mm")}</Text>
                    </View>
                  </View>
                  {
                    data.printAuditoria.valorEsperado.map((item) => {
                      rows = [];

                      const dataNuevo = item.valorNuevo !== "" ? JSON.parse(item.valorNuevo) : "";
                      const dataAntiguo = item.valorAntiguo !== "" ? JSON.parse(item.valorAntiguo) : "";

                      const lista = dataNuevo !== "" ? dataNuevo : dataAntiguo;

                      // Función auxiliar para determinar el estado
                      const determinarEstado = (antiguo, nuevo) => {
                        const antiguoVacio = !antiguo || antiguo === '';
                        const nuevoVacio = !nuevo || nuevo === '';

                        if (antiguoVacio && !nuevoVacio) return '+';
                        if (!antiguoVacio && nuevoVacio) return '-';
                        if (antiguo !== nuevo) return '!';
                        return '=';
                      };

                      for (let i in lista) {
                        const antiguo = dataAntiguo[i] !== undefined ? dataAntiguo[i].toString() : "";
                        const nuevo = dataNuevo[i] !== undefined ? dataNuevo[i].toString() : "";
                        const estado = determinarEstado(antiguo, nuevo);

                        rows.push(createData(i, antiguo, nuevo, estado));
                      }

                      return <>
                        <View style={{ marginTop: "15px", marginBottom: "0px" }}>
                          <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>
                            Tabla: {item.tabla}
                          </Text>
                          <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>
                            Id: {item.idClaveSecundaria}
                          </Text>
                          <Text style={{ fontSize: "11px", fontWeight: "bold", paddingBottom: '5px' }}>
                            Registro Válido: {item.digitoValido ? 'SI' : 'NO'}
                          </Text>
                        </View>
                        <View style={styles.tabla} wrap={true}>
                          <View style={styles.tablaFila}>
                            <View style={styles.tablaColumna1}>
                              <Text style={styles.tablaCeldaHeader}>CAMPO</Text>
                            </View>
                            <View style={styles.tablaColumna2}>
                              <Text style={styles.tablaCeldaHeader}>VALOR ANTIGUO</Text>
                            </View>
                            <View style={styles.tablaColumna2}>
                              <Text style={styles.tablaCeldaHeader}>VALOR NUEVO</Text>
                            </View>
                            <View style={styles.tablaColumna3}>
                              <Text style={styles.tablaCeldaHeader}>ESTADO</Text>
                            </View>
                          </View>
                          <AuditoriaPrintDetalle rows={rows} />
                        </View>
                      </>;
                    })
                  }
                </View>
                <View style={{ marginTop: "15px", marginBottom: "0px", marginLeft: "10px" }}>
                  <Text style={{ fontSize: "10px", fontWeight: "bold", paddingBottom: '5px', textDecoration: 'underline' }}>Referencias:</Text>
                  <Text style={{ fontSize: "10px", fontWeight: "bold", paddingBottom: '5px' }}>= : Campo sin cambios</Text>
                  <Text style={{ fontSize: "10px", fontWeight: "bold", paddingBottom: '5px' }}>+ : Campo agregado</Text>
                  <Text style={{ fontSize: "10px", fontWeight: "bold", paddingBottom: '5px' }}>- : Campo eliminado</Text>
                  <Text style={{ fontSize: "10px", fontWeight: "bold", paddingBottom: '5px' }}>! : Campo modificado</Text>
                </View>

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) =>
                  `${pageNumber} / ${totalPages}`
                } fixed />
              </Page>
            </Document>
          </PDFViewer>
        </div>);

    } else {

      return (
        <>
          <ErrorDialog
            id="dlg-error-terminos"
            open={data.printAuditoria.error != null}
            onClose={handleCloseDlgError}
            mensaje={data.printAuditoria.error} />

        </>);

    }
  }
};